import type { Creator } from '@/modules/creators/types.ts'
import type { BillingPlan, License } from '@/modules/licenses/types.ts'

export interface PotentialUpgrade {
  interval: 'monthly' | 'yearly'
  plan: BillingPlan
}

export function getCurrentLicense(creator: Creator, licenses: License[]) {
  return licenses.find((license) => license.id === creator.licenseId)
}

export function getCurrentPlan(
  creator: Creator,
  licenses: License[],
  plans: BillingPlan[],
) {
  const currentLicense = getCurrentLicense(creator, licenses)

  return (
    currentLicense &&
    plans.find(
      (plan) =>
        plan.name ===
        currentLicense.plan.substring(0, currentLicense.plan.indexOf('_')),
    )
  )
}

export function getPotentialUpgradesByCreator(
  creator: Creator,
  licenses: License[],
  plans: BillingPlan[],
) {
  const currentLicense = getCurrentLicense(creator, licenses)
  const currentPlan = getCurrentPlan(creator, licenses, plans)

  if (!currentPlan || !currentLicense) {
    return []
  }
  const planVariantName = currentLicense.plan.includes('_')
    ? currentLicense.plan.substring(currentLicense.plan.indexOf('_') + 1)
    : ''

  return getPotentialUpgrades(planVariantName, currentPlan, plans)
}

function getPotentialUpgrades(
  variant: string,
  currentPlan: BillingPlan,
  plans: BillingPlan[],
) {
  const upgrades: PotentialUpgrade[] = []

  if (variant !== 'monthly' && variant !== 'yearly') {
    return upgrades
  }

  const isMonthly = variant === 'monthly'
  const currentPrice = isMonthly
    ? currentPlan.monthlyPrice
    : currentPlan.yearlyPrice

  for (const plan of plans) {
    if (plan.level < currentPlan.level) {
      continue
    }

    if (plan.monthlyPrice > currentPrice) {
      upgrades.push({ interval: 'monthly', plan })
    }

    if (plan.yearlyPrice > currentPrice) {
      upgrades.push({ interval: 'yearly', plan })
    }
  }

  return upgrades
}
